import React from "react";
import { Box } from "@mui/material";
import { MyDocumentsSettingsCard } from "my-documents/components";
import { myDocumentsSettingsPageMenuDef } from "my-documents/configs";
import { OcPageSideMenu, OcPageTransition } from "oc/components";
import { useOcPageSideMenu } from "oc/hooks";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const MyDocumentsSettingsPage = () => {
  const stateId = "myDocumentsSettingsPageMenuActiveItem";
  const { state: selectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: myDocumentsSettingsPageMenuDef[0].id,
  });

  const isMobile = useOcIsMobile();

  return (
    <OcPageTransition>
      <Box>
        <Box
          id="my-hr-documents-settings"
          height="80px"
          style={{ backgroundColor: "#cc0033" }}
          display="flex"
          flexDirection="row"
          alignItems="center"
          paddingLeft="14px"
        >
          <Box style={{ color: "white", fontSize: "24px" }}>MyDocuments</Box>
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <OcPageSideMenu
            stateId={stateId}
            menuDef={myDocumentsSettingsPageMenuDef}
          />
          <Box
            id="my-time-admin-settings"
            flexGrow={1}
            padding={isMobile ? "16px 0px" : "16px"}
          >
            {selectedItem === "myDocumentsGeneralSettings" && (
              <Box>
                <MyDocumentsSettingsCard isMobile={isMobile} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </OcPageTransition>
  );
};

export default MyDocumentsSettingsPage;
